import { FlashCardsCollection } from '@containers/card';

export function Cards() {
  return <FlashCardsCollection />;
}
